import * as angular from 'angular';
import CarouselComponent from './carousel-component';

export default angular.module('carousel', []).component('carousel', new CarouselComponent());



// WEBPACK FOOTER //
// ./src/modules/utils/carousel/carousel-module.ts